<template>
  <div class="home">
    <div class="row row-1">
      <user-info class="user-info" :hoursTxt="hoursTxt"></user-info>
      <shortcuts class="shortcuts" :menus="shortcutMenuList" @to="toPage"></shortcuts>
      <policy-express class="policy-express"></policy-express>
    </div>
    <section class="row row-2" v-show=false>
      <advertising class="advertising shadow"></advertising>
    </section>
    <section class="row row-3">
      <role-functions class="role-functions" :hide-approval="hideApproval" :module-list="moduleList" @to="toPage"></role-functions>
      <approval-module class="approval-module" :tabs="homePageApproveInfoVO.tabs" :count="homePageApproveInfoVO.allCount" :style="{ width: setModuleWidth }" @to="toPage" v-if="!hideApproval"></approval-module>
    </section>
    <section class="row row-4">
      <expense-distribution class="expense-distribution"></expense-distribution>
      <trend-analysis class="trend-analysis"></trend-analysis>
    </section>
  </div>
</template>

<script>
import UserInfo from './components/UserInfo'
import Shortcuts from './components/Shortcuts'
import PolicyExpress from './components/PolicyExpress'
import Advertising from './components/Advertising'
import RoleFunctions from './components/RoleFunctions'
import ApprovalModule from './components/ApprovalModule'
import ExpenseDistribution from './components/ExpenseDistribution'
import TrendAnalysis from './components/TrendAnalysis'
import {mapGetters} from 'vuex'

import {getCloudHomePage} from "@/api/home/home";

export default {
  name: "platformTC",
  components: {
    UserInfo,
    Shortcuts,
    PolicyExpress,
    Advertising,
    RoleFunctions,
    ApprovalModule,
    ExpenseDistribution,
    TrendAnalysis
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      hideApproval: false,
      // 快捷菜单
      shortcutMenuList: [],
      // 审批管理
      homePageApproveInfoVO: {},
      // 报销管理、出差申请、借款申请、供应商合同、开票管理、印鉴申请等模块信息
      moduleList: [],
      hoursTxt: "",
    }
  },
  methods: {
    getData() {
      let param = {
        customId: this.userInfo.cusId,
        branchId: this.userInfo.branchId
      };
      getCloudHomePage(param).then(res => {
        let result = res.data.data;
        this.hoursTxt = result.otherResult.hoursTxt;
        this.shortcutMenuList = result.shortcutMenuList;
        this.homePageApproveInfoVO = result.homePageApproveInfoVO;
        this.moduleList = result.moduleList;
        this.hideApproval = !result.homePageApproveInfoVO.hasPermission
      });
    },
    toPage(val) {
      let { url } = val
      var urlArry = url.split("?");
      if(urlArry.length == 1){
        this.$router.push({
          path: url
        })
      }else{
        if(urlArry[0].indexOf("action") > -1){
          this.$router.push({
            path: urlArry[0],
            query: {accountingParams:urlArry[1]}
          })
        }else{
          var params = {};
          var paramArray = urlArry[1].split("&");
          for (var i = 0; i < paramArray.length; i++) {
            var paramKY = paramArray[i].split("=");
            this.$set(params, paramKY[0], paramKY[1]);
          }

          this.$router.push({
            path: urlArry[0],
            query: params
          })
        }

      }

    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    setModuleWidth() {
      return `calc((100% - 155px) / 4 + 70px)`
    }
  }
};
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
  .card {
    height: 100%;
  }
}

.row-1 {
  height: 180px;
}

.row-3 {
  height: 170px;
}

.row-4 {
  height: 450px;
}

.user-info {
  width: 260px;
}

.shortcuts {
  flex: 1;
}

.policy-express {
  flex: 1;
}

.advertising {
  flex: 1;
  background-color: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  padding: 0 6px;
}

.role-functions {
  flex: 1;
}

.approval-module {
  margin-left: 15px;
}

.expense-distribution,
.trend-analysis {
  flex: 1;
}
</style>
